import { apiClient } from 'pobble-components/dist/api'

const apiGetMe = params => apiClient.get('v3/me', { params })

const apiGetAccount = (id, params) =>
  apiClient.get(`v3/accounts/${id}`, { params })

export { apiGetMe, apiGetAccount }
